  <template>
  <div class="FAQ">
    <BasiceLayout
      title="FAQ"
      class="bonus-code-layout"
      :more="$t('faq_link')"
    >
      <div class="qa-item">
        <div class="question">
          <span class="faq-icon">Q</span>
          <el-select
            class="faq-tip-background revenue-select"
            v-model="value"
            @change="changeAnswer"
          >
            <el-option
              v-for="item in options"
              :key="item.question"
              :label="item.question"
              :value="item.question"
            >
            </el-option>
          </el-select>
        </div>
        <div class="answer revenue-answer">
          <span class="faq-icon answer-icon">A</span>
          <div class="faq-tip-background">
            <div class="tipContent answerContent">
              <div v-if="answer && typeof answer !== 'string' && answer.length">
                <div v-for=" item in answer">
                  {{item}}
                </div>
              </div>
              <div v-else>{{ answer || this.$t("questions")[0].answer  }}</div>
            </div>
          </div>
        </div>
      </div>
    </BasiceLayout>
  </div>
  <!-- </div> -->
</template>

<script>
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import { answers } from "@/config/RevenueFAQ.js";

export default {
  name: "FAQ",
  components: {
    BasiceLayout
  },
  props: {
    FAQ: ""
  },
  data() {
    return {
      options: this.$t("questions"),
      value: this.$t("questions")[0].question,
      answer: ""
    };
  },
  methods: {
    changeAnswer(val) {
      this.answer = answers[val];
    }
  }
};
</script>

<i18n>
{
	"en": {
    "questions": [
      {
        "question": "What is network task?",
        "answer": "Network tasks mainly provide IP resources to the demand-side for pressure measurement, concurrent simulation, performance detection and other applications, which do not occupy uplink bandwidth. "
      },
      {
        "question": "What is the network task’s revenue overall and total reward?"
      },
      {
        "question": "Which is the network task’s reward algorithm?"
      },
      {
        "question": "What is computing task?"
      },
      {
        "question": "What is the total reward for computing task?"
      },
      {
        "question": "Which is the computing task’s reward algorithm?"
      },
      {
        "question": "Storage task reward"
      }
    ]
	},
  	"zn": {
      "questions": [
        {
          "question": "什么是网络任务",
          "answer": "网络任务主要为资源需求方提供IP资源，用于完成压测，并发模拟、性能检测等应用，不占用上行带宽。进行网络任务需要设备提供 公网IP 资源，并确保网络较为通畅，没有严重的掉线、延迟、丢包等情况。"
        },
        {
          "question": "网络任务的收益情况及奖励总额？"
        },
        {
          "question": "网络任务收益的收益计算方式："
        },
        {
          "question": "什么是计算任务？"
        },
        {
          "question": "计算任务的奖励总额？"
        },
        {
          "question": "计算任务的收益计算方式？"
        },
        {
          "question": "存储任务收益"   
        }          
      ]
  	}
}
</i18n>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scopes lang="stylus">
.about-center {
  margin: 10px 0;
}

.revenue-select {
  min-width: 300px;
}

.faq-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  // background-image: linear-gradient(-180deg, #15BCAD 2%, #10B2CB 100%)
  background: #0DB4C5;
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #FFFFFF;
  text-align: center;
  line-height: 20px;
  margin: 10px 20px 0 0;
  vertical-align: bottom;
  position: absolute;
  left: 0;
}

.faq-tip-background {
  height: 30px;
  margin-left: 40px;
}

.tipIcon {
  display: inline-block;
  width: 0;
  height: 0;
  border: 3px solid transparent;
  border-bottom-color: #0DB4C5;
  border-right-color: #0DB4C5;
  vertical-align: bottom;
}

.tipContent {
  background: #0DB4C5;
  display: inline-block;
  font-size: 12px;
  color: #FFFFFF;
  line-height: 30px;
  padding: 0 20px;
  min-width: 250px;
  border-radius: 4px 4px 4px 0;
}

.faq-tip-background {
  display: inline-block;
}

.qa-item {
  margin-bottom: 22px;
}

.answer, .question {
  position: relative;
}

.answer-icon {
  font-size: 12px;
  color: #999B98;
  text-align: center;
  line-height: 18px;
  background: #F5F5F6;
}

.answerContent {
  color: #65686A;
  background: #F5F5F6;
  padding: 10px 20px;
}

.answer {
  margin: 18px 0 28px;
}

.answerIcon {
  border-bottom-color: #F5F5F6;
  border-right-color: #F5F5F6;
}

.bold {
  font-weight;
}

.revenue-answer {
  margin-top: 40px;
  margin-bottom: 60px;
}
</style>

